import React from 'react';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const JswConfigHeader = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<PageHeader>{formatMessage(messages.jswConfigHeaderSpork)}</PageHeader>
		</>
	);
};
